import { makeStyles } from '@material-ui/core';

import constants from '../../../../abstracts/constants';
import colors from '../../../../abstracts/colours';

export const useStyles = makeStyles({
  root: {
    textTransform: 'none',
    fontSize: constants.LARGE,
    fontFamily: constants.sourceSansPro,
    color: colors.greyishBrown,
    opacity: 1,
    '&:hover': {
      color: colors.scienceBlue,
    },
  },
  selected: { fontWeight: 800, color: colors.scienceBlue },
});
